"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveRetryConfig = void 0;

var tslib_1 = require("tslib");

var defaultStrategy_1 = require("./defaultStrategy");

exports.resolveRetryConfig = function (input) {
  var _a;

  var maxAttempts = (_a = normalizeMaxAttempts(input.maxAttempts)) !== null && _a !== void 0 ? _a : input.maxAttemptsDefaultProvider(input);
  return tslib_1.__assign(tslib_1.__assign({}, input), {
    maxAttempts: maxAttempts,
    retryStrategy: input.retryStrategy || new defaultStrategy_1.StandardRetryStrategy(maxAttempts)
  });
};

var normalizeMaxAttempts = function normalizeMaxAttempts(maxAttempts) {
  if (maxAttempts) {
    var promisified_1 = Promise.resolve(maxAttempts.toString());
    return function () {
      return promisified_1;
    };
  }
};